export default "/images/vendor/flag-icon-css/flags/4x3/bv.svg?b789f839eda2bce4b0e344610c23e9f7";